import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import type {
  OrganizationComponents,
  OrganizationPaths
} from '@/api/organization-client'
import { getOrganizationClient } from '@/api/organization-client'

export type Segment = OrganizationComponents.Schemas.Segment
export type SegmentConflictResponse =
  OrganizationPaths.CreateSegment.Responses.$409

const client = getOrganizationClient()

export enum SEGMENT_QUERY_IDS {
  GET_SEGMENTS = 'SEGMENTS_GET_SEGMENTS'
}

export interface SegmentApiError {
  message?: string
  response?: {
    status?: number
    data?:
      | Segment
      | SegmentConflictResponse
      | { error?: string; message?: string }
  }
}

export const useQuerySegments = () =>
  useQuery<Segment[]>({
    queryKey: [SEGMENT_QUERY_IDS.GET_SEGMENTS],
    queryFn: () =>
      client.getSegments().then((response) => response.data.segments),
    staleTime: 5 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false
  })

export const useMutationCreateSegment = () => {
  const queryClient = useQueryClient()

  return useMutation<Segment, SegmentApiError, string>({
    mutationFn: (label) =>
      client.createSegment(null, { label }).then((response) => response.data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [SEGMENT_QUERY_IDS.GET_SEGMENTS]
      })
    }
  })
}
